<template>
  <div id="purchaseSummary" class="gradient-card card">
    <div class="header">
      <div :class="panelHeaderIconClass"></div>
        <h4 class="title">{{ panelHeaderTitle }}</h4>
      </div>

    <div class="body">
      <div v-if="invoiceSummary !== null" class="purchase-summary">
        <div class="plan-name">&nbsp;</div>
        <perfect-scrollbar class="order cstm-ps-scrollbar-vertical">
          <table class="purchase-details-table">
            <thead>
              <tr>
                <th>{{$t('label.plan', 1)}}</th>
                <th>{{$t('label.player', 2)}}</th>
                <th>{{$t('label.priceSlashMonth')}}</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th colspan="4"></th>
              </tr>
              <tr>
                <th colspan="4">
                  <div class="item subtotal">
                    <div class="label">{{$t('label.subtotal')}}</div>
                    <div class="value">{{`${invoiceSummary._edit.subtotalWithCurrency}`}}</div>
                  </div>
                  <div class="item vat">
                    <div class="label">{{`${$t('label.vat')} ${invoiceSummary._edit.vatInPercentWithLabel}`}}</div>
                    <div class="value">{{`${invoiceSummary._edit.vatWithCurrency}`}}</div>
                  </div>
                  <div class="item total">
                    <div class="label">{{$t('label.total')}}</div>
                    <div class="value">{{invoiceSummary._edit.amountWithCurrency}}</div>
                  </div>
                </th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="(item, planName) in invoiceSummary._edit.itemsGroupByPlanName" :key="planName">
                <td>{{planName}}</td>
                <td>{{item.length}}</td>
                <td>{{`${invoiceSummary.currency} ${item[0].value}`}}</td>
              </tr>
            </tbody>
          </table>
        </perfect-scrollbar>

        <div class="terms-and-conditions">
          <span class="lbl-1">{{$t('plans.review.termsAndConditionsMain')}}</span>
          <span v-if="hasTermsOfSale" @click="$utils.downloadDocument({ url: '/static/docs/SpinetiX-General-Terms-and-Conditions-of-Sale.pdf', label: 'SpinetiX-General-Terms-and-Conditions-of-Sale.pdf'})" class="lbl-2">{{$t('plans.review.termsAndConditionsSub')}}</span>
        </div>
      </div>

      <div class="action-btn-wrapper">
        <el-button v-if="showCancelButton" @click="handleActionButtonClick('cancel')" class="cstm-btn-white">{{$t('label.cancel')}}</el-button>
        <el-button @click="handleActionButtonClick('confirm')" class="cstm-btn-white">{{$t('label.confirm')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script src="./user-purchase-summary.js"></script>
<style lang="scss" src="./user-purchase-summary.scss"></style>
